var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-center",attrs:{"id":"home"}},[_c('div',{staticClass:"background"},[_c('h1',[_vm._v("Welcome to Pizza Place")]),_vm._v(" "),_c('h2',[_vm._v("Feeling Hungry?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.goToMenu}},[_vm._v("Let's Order")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-158d697b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 48
// module chunks = 0